const discover = {
  "discover.page_title": "Discover Define®",
  "discover.trait_01.body": "Pigments are safely embedded within the lens material, so that they don’t come in contact with your eyes.",
  "discover.trait_01.title": "<em>Beauty Wrapped In Comfort™ </em> technology",
  "discover.trait_02.body": "Stay safe from harmful UV radiation with one of the highest UV protection levels available in a daily disposable contact lens.",
  "discover.trait_02.title": "<em>All-day UV protection</em> and confidence",
  "discover.trait_03.body": "A harmonious blend of three translucent, hand-drawn layers crafted to highlight, accentuate and naturally blend into the iris.",
  "discover.trait_03.title": "<em>Layered</em> print process",
  "discover.trait_04.item_01.body": "Thin on-eye edge profile designed to curb lid irritation when blinking.",
  "discover.trait_04.item_01.title": "Edge design",
  "discover.trait_04.item_02.body": "Technology that is designed to support the tear film to help minimise dryness.",
  "discover.trait_04.item_02.title": "Wettability**",
  "discover.trait_04.item_03.body": "A lower modulus wraps the eye with less lid and cornea mechanical resistance for increased comfort.",
  "discover.trait_04.item_03.title": "Modulus",
  "discover.trait_04.title": "Crafted for <em>all-day comfort</em>",
}

export const try_lenses = {
  "try_lenses.block_title": "Try on <span>ACUVUE® Define® </span>lenses virtually",
  "try_lenses.virtual_mirror": "Virtual Mirror",
}

export const product_range = {
  "product_range.block_title": "Find the perfect <span>ACUVUE® Define®</span> for you",
  "product_range.button.classic": "Discover Define® Classic",
  "product_range.button.fresh": "Discover Define® Fresh",
}

const discover_references = {
  "discover_references_link": "https://www.acuvue.com.sg/patient-instruction-guide/",
  get discover_references() {
    return `
    <h1>REFERENCES/ DISCLAIMER</h1>
    <p> ** LACREON* Technology is Johnson & Johnson Vision Care, Inc.'s brand name for its proprietary technology that permanently embeds a water-holding ingredient, similar to that found in natural tears, into the proven etafilcon A material. </p> <h2>Important information for contact lens wearers</h2>
    <p>ACUVUE® Brand Contact Lenses are available by prescription only for vision correction. An eye care professional will determine whether contact lenses are right for you. Although rare, serious eye problems can develop while wearing contact lenses. To help avoid these problems, follow the wear and replacement schedule and the lens care instructions provided by your eye doctor. Do not wear contact lenses if you have an eye infection, or experience eye discomfort, excessive tearing, vision changes, redness or other eye problems. If one of these conditions occurs, contact your eye doctor immediately. For more information on proper wear, care and safety, talk to your Eye Care Professional or refer to ACUVUE®'s
    <a href="${this.discover_references_link}"> Patient Instruction Guide</a>.</p>`
  }
}


// export default discover;
export default {
  ...discover,
  ...try_lenses,
  ...product_range,
  ...discover_references
}
